export const filterPanelProps = {
  '& .MuiDataGrid-filterForm': {
    width: '100%',
    // padding: '10px',
    borderRadius: '8px',
    display: 'flex', // Make the form a flex container
    alignItems: 'center', // Vertically align items in the center
    gap: '16px', // Add space between each form element
    '& .MuiFormControl-root': {
      flex: '1 1 auto',
      margin: '0',
      minWidth: '100px',
      '& .MuiInputBase-root': {
        padding: '4px', // Adjust padding for input fields
        borderRadius: '4px',
      },
    },
  },
  '& .MuiDataGrid-filterFormValueInput': {
    flex: '2 1 auto', // Allow the value input more space
    minWidth: '150px', // Minimum width for input
    '& input': {
      padding: '6px 8px', // Adjust padding for the input field
      width: '100%',
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: '18px', // Decrease the size of the 'x' icon
  },
}
